'use client';

import { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getServiceCategoryById } from '@/lib/actions/service-categories';
import { CategoryForm } from '@/components/admin/services/CategoryForm';

export default function AdminServiceCategoryEditPage() {
  const { id } = useParams<{ id: string }>();
  const [category, setCategory] = useState<Awaited<ReturnType<typeof getServiceCategoryById>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    getServiceCategoryById(id).then((data) => {
      setCategory(data);
      setLoading(false);
    });
  }, [id]);

  if (loading) {
    return null;
  }

  if (!category) {
    return <Navigate to="/admin/services/categories" replace />;
  }

  return <CategoryForm initialData={category} />;
}
